
export class LOVPaymentMethodExtension {
}
